module.exports = __webpack_public_path__ + "img/kalis_login_emblem.2823e266.svg";